/**
 * Hashes `file` with SubtleCrypto so New Job can look an extraction up by content before
 * spending any time parsing it (PTX-D9, QZ-D83).
 */
export const hashFile = async (file: Blob): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
};
